import CircularProgress from "@material-ui/core/CircularProgress";
import { LoggedOutPageContainer } from "components/pageLayouts/pageLayouts.styled";
import { ReactElement } from "react";
import { useAuthStore } from "stores/authStore/authStore";
import { CompanySettingsV2 } from "web-apps/company/components/companySettingsV2/companySettingsV2.component";
import { useCompanyStore } from "web-apps/company/stores/companyStore/companyStore";

export const CompanySettingsV2Page = (): ReactElement => {
  const [authState] = useAuthStore();
  const [companyState] = useCompanyStore();

  if (companyState.isLoading || authState.isLoading) {
    return (
      <LoggedOutPageContainer>
        <CircularProgress />
      </LoggedOutPageContainer>
    );
  }

  return <CompanySettingsV2 />;
};
